module.exports = __webpack_public_path__ + "img/postback-step-3.en.169340a6.jpg";